const ITEMS = [
  "First draft in 48 hours",
  "Live in 72 hours",
  "$800 one-time",
  "Hosting included for a year",
  "No agency fees",
  "Built to capture leads",
  "Mobile-first",
  "SSL included",
];

export const Marquee = () => (
  <div
    className="marquee-mask overflow-hidden border-y border-white/5 bg-card/60 py-5"
    data-testid="speed-strip-marquee"
    aria-label="First draft in 48 hours, live in 72 hours, 800 dollars one-time, hosting included"
  >
    <div className="flex w-max animate-marquee items-center gap-10 pr-10">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span
          key={i}
          aria-hidden={i >= ITEMS.length}
          className="flex items-center gap-10 whitespace-nowrap font-mono text-xs uppercase tracking-[0.25em] text-mist sm:text-sm"
        >
          {item}
          <span className="h-1.5 w-1.5 rounded-full bg-volt shadow-[0_0_12px_rgba(0,240,255,0.8)]" />
        </span>
      ))}
    </div>
  </div>
);
